<div class="characteristic">
  <figure>
    <img
      [src]="'assets/perval-icons/' + characteristicItem.icon"
      [alt]="characteristicItem.label"
    />
    <figcaption class="text-uppercase">
      {{ characteristicItem.label }}
    </figcaption>
  </figure>
  <span *ngIf="characteristicItem.numValue">
    {{ characteristicItem.numValue | number: "1.0-2" }}
    {{ characteristicItem.unit ? characteristicItem.unit : "" }}
  </span>
  <span *ngIf="characteristicItem.strValue">
    {{ characteristicItem.strValue }}
  </span>
  <span *ngIf="!characteristicItem.strValue && !characteristicItem.numValue">
    -
  </span>
</div>
